/** 月狀態（與 App\WorkScheduleMonthState 的常數一一對應） */
export const MONTH_STATUS = {
    DRAFTING: 'drafting',
    LOCKED: 'locked',
    PUBLISHED: 'published',
};

/** 個人完成狀態（與 App\WorkScheduleMemberState 一一對應） */
export const MEMBER_STATE = {
    PENDING: 'pending',
    DONE: 'done',
    CHANGED: 'changed_after_done',
};

export const MEMBER_STATE_STYLE = {
    [MEMBER_STATE.PENDING]: { background: '#eceff1', color: '#546e7a', border: '#cfd8dc' },
    [MEMBER_STATE.DONE]: { background: '#e8f5e9', color: '#2e7d32', border: '#a5d6a7' },
    [MEMBER_STATE.CHANGED]: { background: '#fff3e0', color: '#e65100', border: '#ffb74d' },
};

export const MONTH_STATUS_STYLE = {
    [MONTH_STATUS.DRAFTING]: { background: '#4caf50', color: '#fff' },
    [MONTH_STATUS.LOCKED]: { background: '#ff9800', color: '#fff' },
    [MONTH_STATUS.PUBLISHED]: { background: '#1976d2', color: '#fff' },
};

/**
 * 左鍵快捷畫的那一格：一般休・整天。
 * ⛔ 前端不自己發明假別 —— 值必須對得上後端 category_options 裡真的有的那一個
 *    （遠期預假階段只有 general_rest，標籤是「預假」；正式排班階段是「一般休」）。
 */
export const QUICK_CATEGORY = 'general_rest';
export const QUICK_PERIOD = 'full';

/** 後端給的假別選項裡，左鍵快捷要用的那一個；找不到就退而用第一個選項 */
export const quickCategoryOf = (options) => {
    const list = options || [];

    return list.find((c) => c.value === QUICK_CATEGORY) || list[0] || null;
};

/**
 * 觸控裝置（手機／平板）沒有左右鍵之分：點一下一律開精簡選單，
 * ⛔ 不可因為桌機改成「左鍵＝一般休」就讓手機選不到特休與上／下半天。
 */
export const isCoarsePointer = () =>
    !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

/** 姓名欄與狀態欄的寬度：兩欄都要 sticky，位移量必須跟寬度一致 */
export const NAME_COL_WIDTH = 110;
export const STATE_COL_WIDTH = 118;

export const shiftMonth = (year, month, delta) => {
    const base = new Date(year, month - 1 + delta, 1);
    return { year: base.getFullYear(), month: base.getMonth() + 1 };
};

export const currentMonth = () => {
    const now = new Date();
    return { year: now.getFullYear(), month: now.getMonth() + 1 };
};

/**
 * 沒指定年月時的預設＝**下個月**：9 月打開這一頁，要劃的是 10 月的假。
 * ⚠️ 後端 ScheduleCoordinationController::resolveMonth() 用同一個定義，兩邊不可以各算各的。
 */
export const defaultMonth = () => {
    const now = new Date();
    const base = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    return { year: base.getFullYear(), month: base.getMonth() + 1 };
};

/**
 * 初始月份：網址帶 ?year=&month= 就用它，否則用預設（下個月）。
 * ⚠️ 有帶就完全照帶的走，⛔ 不可以每次載入又跳回下個月。
 * 有網址參數，店長才能把「2027年3月的協調頁」直接貼給人看。
 */
export const monthFromLocation = () => {
    const params = new URLSearchParams(window.location.search);
    const year = parseInt(params.get('year'), 10);
    const month = parseInt(params.get('month'), 10);

    if (year >= 2000 && year <= 2100 && month >= 1 && month <= 12) {
        return { year, month };
    }

    return defaultMonth();
};

/** 切換月份時同步網址，重新整理才會停在同一個月 */
export const syncLocationMonth = (year, month) => {
    if (!window.history || !window.history.replaceState) return;
    const params = new URLSearchParams(window.location.search);
    params.set('year', String(year));
    params.set('month', String(month));
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
};
